export default __webpack_public_path__ + "static/media/pristine-609.9287f5ce.mp3";